export const MESSAGGIO_ERRORE_1 = 'Sembra ci sia un errore. Controlla di aver inserito un indirizzo corretto'
export const TORNA_ALLA_HOME_STRING = 'Torna alla home'